import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import IntensiveEnglishRoute from "./English";

export const IntensiveRoutes = () => (
  <Routes>
    <Route path="/intensive-english" element={<IntensiveEnglishRoute />} />
    <Route path="*" element={<Navigate to="/intensive-english" />} />
  </Routes>
);
